import type { FC } from "react";
import React from "react";

import type { UserId } from "@core/domains/identity";

import { Button } from "@react/ui-primitives/button";
import { DialogFooter } from "@react/ui-primitives/dialog";
import {
  Field,
  FieldContent,
  FieldError,
  FieldLabel,
} from "@react/ui-primitives/field";
import { Input } from "@react/ui-primitives/input";

import { useTopUpForm } from "../hooks/useTopUpForm.ts";

interface TopUpFormProps {
  readonly onSuccess: () => void;
  readonly principalId: UserId;
}

export const TopUpForm: FC<TopUpFormProps> = ({ onSuccess, principalId }) => {
  const form = useTopUpForm({ onSuccess, principalId });

  return (
    <form className="space-y-4 py-4" onSubmit={form.handleSubmit}>
      <Field>
        <FieldLabel>Amount (USD)</FieldLabel>
        <FieldContent>
          <div className="relative">
            <span className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-muted-foreground">
              $
            </span>
            <Input
              className="pl-7"
              placeholder="0.00"
              step="1"
              type="number"
              {...form.register("amount")}
            />
          </div>
          <FieldError errors={[form.state.errors.amount]} />
        </FieldContent>
      </Field>
      <Field>
        <FieldLabel>Description (optional)</FieldLabel>
        <FieldContent>
          <Input
            placeholder="Reason for top-up"
            {...form.register("description")}
          />
          <FieldError errors={[form.state.errors.description]} />
        </FieldContent>
      </Field>
      <DialogFooter>
        <Button
          disabled={form.state.isSubmitting || !form.state.isValid}
          type="submit"
        >
          {form.state.isSubmitting ? "Processing…" : "Confirm Top Up"}
        </Button>
      </DialogFooter>
    </form>
  );
};
